export default __webpack_public_path__ + "static/media/basic-search.1fb2747b.svg";